module.exports = __webpack_public_path__ + "static/img/active-ingr-no-01.73588a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/active-ingr-no-01.jpg
// module id = 244
// module chunks = 1